/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const QuoteIcon = /*#__PURE__*/ createSvgIcon(
  'QuoteIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.917 12.875l.895-1.563c-.652 0-1.229-.259-1.729-.777s-.75-1.14-.75-1.868c0-.75.257-1.382.771-1.896S6.25 6 7 6s1.382.257 1.896.77c.514.515.77 1.147.77 1.897 0 .208-.03.42-.093.635a3.606 3.606 0 01-.281.677l-2.084 3.646a.735.735 0 01-.646.375.712.712 0 01-.656-.375.684.684 0 01.01-.75zm6 0l.895-1.563c-.652 0-1.229-.259-1.729-.777s-.75-1.14-.75-1.868c0-.75.257-1.382.771-1.896S12.25 6 13 6s1.382.257 1.896.77c.514.515.77 1.147.77 1.897 0 .236-.03.465-.093.687-.063.222-.15.43-.26.625l-2.105 3.646a.735.735 0 01-.646.375.712.712 0 01-.656-.375.684.684 0 01.01-.75zM6.995 9.833c.323 0 .599-.113.828-.338.229-.226.344-.5.344-.823 0-.323-.113-.6-.34-.828-.225-.23-.5-.344-.822-.344-.323 0-.599.113-.828.339-.23.226-.344.5-.344.823 0 .322.113.598.339.828.226.229.5.343.823.343zm6 0c.323 0 .599-.113.828-.338.229-.226.344-.5.344-.823 0-.323-.113-.6-.34-.828-.225-.23-.5-.344-.822-.344-.323 0-.599.113-.828.339-.23.226-.344.5-.344.823 0 .322.113.598.339.828.226.229.5.343.823.343z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default QuoteIcon;
